import React from 'react'
import PropTypes from 'prop-types'
import Button, { TYPES } from '../Button/index'

export const ALIGN_CENTER = 'center'
export const ALIGN_LEFT = 'left'

function GenericMessage (props) {
  const {
    message,
    redirectMsg = null,
    redirecTo = null,
    align = ALIGN_CENTER,
  } = props

  return (
    <div className={`generic-message__${align}`}>
      <p>{message}</p>
      {(redirectMsg && redirecTo)
        && <Button
          url={redirecTo}
          type={TYPES.PRIMARY}
        >
          {redirectMsg}
        </Button>
      }
    </div>
  )
}

GenericMessage.propTypes = {
  message: PropTypes.string.isRequired,
  redirectMsg: PropTypes.string,
  redirecTo: PropTypes.string,
  align: PropTypes.oneOf([ALIGN_CENTER, ALIGN_LEFT]),
}

export default GenericMessage
